import { Link } from "react-router-dom";
import {
    ArrowUpRight,
    Radar,
    Plane,
    Crosshair,
    Target,
    Shield,
    Layers,
    Activity,
    Lock,
} from "lucide-react";
import ContactSection from "../components/sections/ContactSection";
import "./DefencePage.css";
import Defence_BG from "../components/ui/Defence.png";
import RadarImg from '../components/ui/Radar and Missile Training.png'
import Drone from '../components/ui/Drone Piloting.png'
import TankImg from '../components/ui/Tank and AFV Simulators.png'
import VPImg from '../components/ui/Virtual_parachute_jump_training.png'
import CQBImg from '../components/ui/CQB and Squad VR.png'
import CustomImg from '../components/ui/custom mission rehearsal.png'



const MODULES = [
    {
        icon: Radar,
        title: "Radar & Missile Training",
        img: RadarImg,
        desc: "High-fidelity simulation systems for SAM, AAA, surveillance, and radar operations with instructor-led, scenario-based mission training. ",
        spec: ["Scenario-Based Training", "AAR Analytics", "Threat Library"],
    },
    {
        icon: Plane,
        title: "Drone Piloting",
        img: Drone,
        desc: "Advanced UAV simulators for BVLOS, FPV, and tactical drone operations featuring realistic terrain, payload physics, and sensor integration.",
        spec: ["Geo-Specific Terrain", "EO/IR Payload", "Swarm Rehearsal"],
    },
    {
        icon: Crosshair,
        title: "Tank & AFV Simulators",
        img: TankImg,
        desc: "Immersive armoured fighting vehicle simulators for driver, commander, gunner, and loader training with coordinated crew operations. ",
        spec: ["Crew Coordination", "Motion Simulation", "Networked Training"],
    },
    {
        icon: Target,
        title: "Virtual Parachute Jumps",
        img: VPImg,
        desc: "Realistic HALO, HAHO, and static-line parachute training with dynamic weather, wind simulation, and equipment fidelity.",
        spec: ["Equipment Integration", "Dynamic Weather", "Mission Scenarios"],
    },
    {
        icon: Shield,
        title: "CQB & Squad VR",
        img: CQBImg,
        desc: "Immersive close-quarters battle training with multi-user collaboration, Rules of Engagement (ROE) scenarios, and comprehensive After Action Review (AAR). ",
        spec: ["Multi-User Training", "Voice & Gesture", "After Action Review"],
    },
    {
        icon: Layers,
        title: "Custom Mission Rehearsal",
        img: CustomImg,
        desc: "Bespoke mission-rehearsal systems built to unit-specific TTPs and theatre conditions.",
        spec: ["Classified-Grade", "On-Prem Deployment", "Custom Hardware"],
    },
];



export default function DefencePage() {

    return (
        <main data-testid="defence-page" className="bg-black">
            {/* Hero */}
            <section className="position-relative df-hero border-bottom overflow-hidden">
                <div
                    className="hero-bg-image"
                    style={{ backgroundImage: `url(${Defence_BG})` }}
                    aria-hidden
                />
                <div className="hero-overlay" aria-hidden />
                <div className="grain position-absolute top-0 bottom-0 start-0 end-0 pe-none" aria-hidden />

                <div className="position-relative container-db w-100 mb-4">


                    <span className="font-mono-tech section-eyebrow mb-4 fade-in-up fs-5">
                        ⟶ Make in India | Defence Training Solutions
                    </span>

                    <h1
                        data-testid="defence-page-title"
                        className="font-heading hero-title mb-0"
                    >
                        Train as you'll
                        <br />
                        <span className="text-primary-custom">Fight</span>
                    </h1>
                    <p className="text-muted-custom leading-relaxed max-w-2xl mt-4 mb-0" style={{ fontSize: '20px' }}>
                        DB Productions designs and delivers mission-critical simulation systems for the Indian Armed Forces, combining immersive technologies with engineering excellence to create realistic, battlefield-ready training environments.
                    </p>
                </div>
            </section>

            {/* Capability strip */}
            <section className="py-5 border-bottom border-secondary">
                <div className="container-db">
                    <div className="row g-3">
                        {[
                            { i: Activity, k: "Real-time Sims", v: "60 FPS" },
                            { i: Lock, k: "Security", v: "On-prem" },
                            { i: Shield, k: "Indigenous", v: "100%" },
                            { i: Target, k: "Modules", v: "12+" },
                        ].map(({ i: Icon, k, v }) => (
                            <div key={k} className="col-6 col-md-3" data-testid={`defence-spec-${k.replace(/\s+/g, "-").toLowerCase()}`}>
                                <Icon size={30} className="text-primary-custom mb-3" />
                                <div className="font-heading df-spec-val">
                                    {v}
                                </div>
                                <div className="font-mono-tech df-spec-label mt-2">
                                    {k}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Modules detailed */}
            <section className="py-5 py-md-10 border-bottom border-secondary">
                <div className="container-db">
                    <div className="font-mono-tech section-eyebrow mb-4 fade-in-up fs-5">
                        ⟶ Mission Modules
                    </div>
                    <h2 className="font-heading section-heading mb-5">
                        Operator-grade
                        <br />
                        simulators<span className="text-primary-custom"></span>
                    </h2>

                    <div className="row g-4">
                        {MODULES.map((m) => {
                            const Icon = m.icon;
                            return (
                                <div key={m.title} className="col-12 col-md-6">
                                    <article
                                        data-testid={`defence-page-module-${m.title.replace(/\s+/g, "-").toLowerCase()}`}
                                        className="h-100 d-flex flex-column df-module-card-alt group overflow-hidden"
                                    >
                                        {m.img && (
                                            <div className="df-module-card-img-wrapper position-relative overflow-hidden">
                                                <img src={m.img} alt={m.title} className="df-module-card-img w-100" />
                                                <div className="df-module-card-img-overlay" />
                                            </div>
                                        )}
                                        <div className="p-4 d-flex flex-column gap-3 flex-grow-1">
                                            <div className="d-flex align-items-center gap-3">
                                                <Icon size={30} className="text-primary-custom" />
                                                <h3 className="font-heading df-module-card-title m-0" style={{ color: '#40e0d0' }}>
                                                    {m.title}
                                                </h3>
                                            </div>
                                            <p className="text-muted-custom leading-relaxed m-0 flex-grow-1">{m.desc}</p>
                                            <ul className="list-unstyled d-flex flex-wrap gap-2 m-0 p-0 df-module-spec-list">
                                                {m.spec.map((s) => (
                                                    <li
                                                        key={s}
                                                        className="font-mono-tech df-module-spec-item"
                                                    >
                                                        {s}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </article>
                                </div>
                            );
                        })}
                    </div>

                    <div className="mt-5">
                        <Link
                            to="/contact?interest=Defence Training"
                            data-testid="defence-page-rfp"
                            className="hero-btn-primary font-mono-tech text-decoration-none text-dark fw-bold"
                        >
                            Discuss Your Requirements
                            <ArrowUpRight size={16} />
                        </Link>
                    </div>
                </div>
            </section>

            <ContactSection defaultInterest="Defence Training" />
        </main>
    );
}
